import { render, staticRenderFns } from "./employeeSidebar.vue?vue&type=template&id=a70e88f8&scoped=true"
import script from "./employeeSidebar.vue?vue&type=script&lang=js"
export * from "./employeeSidebar.vue?vue&type=script&lang=js"
import style0 from "./employeeSidebar.vue?vue&type=style&index=0&id=a70e88f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70e88f8",
  null
  
)

export default component.exports